namespace TabAurous.Inventory {
    export interface SKURepricingDetailsForm {
        ProductCode: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        DesignId: Serenity.ServiceLookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
    }

    export class SKURepricingDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKURepricingDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKURepricingDetailsForm.init)  {
                SKURepricingDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;

                Q.initFormType(SKURepricingDetailsForm, [
                    'ProductCode', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w1,
                    'DesignId', w3,
                    'BrandId', w1,
                    'SuperTypeId', w1,
                    'CollectionId', w1,
                    'Pieces', w4,
                    'Weight', w5,
                    'NetWeight', w5
                ]);
            }
        }
    }
}
